import TYPES from './types';
import { put, post } from 'utils/api';
import { successHandler } from 'common/utils/notifications';
import { updateTableRow, resetTableRowUpdate } from 'store/tables/lists/actions';

export const updateAirport = params => dispatch => {
  const { id, table, ...rest } = params;

  dispatch({ type: TYPES.UPDATE_AIRPORT.START, payload: params });

  return put(`/enums/airports/${id}`, { ...rest })
    .then(response => {
      dispatch({ type: TYPES.UPDATE_AIRPORT.SUCCESS, payload: response.data });
      dispatch(updateTableRow({ data: response.data.data, table }));
      dispatch(successHandler({ title: 'Success!', message: 'Updated successfully' }));
      return response.data;
    })
    .catch(error => {
      dispatch({ type: TYPES.UPDATE_AIRPORT.ERROR, payload: { response: error, params } });
      dispatch(resetTableRowUpdate({ data: params, table }));
      return error;
    });
};

export const createAirport = params => dispatch => {
  const { table, ...rest } = params;

  dispatch({ type: TYPES.CREATE_AIRPORT.START, payload: params });

  return post(`/enums/airports`, { ...rest })
    .then(response => {
      dispatch({ type: TYPES.CREATE_AIRPORT.SUCCESS, payload: response.data });
      dispatch(successHandler({ title: 'Success!', message: 'Created successfully' }));

      return response.data;
    })
    .catch(error => {
      dispatch({ type: TYPES.CREATE_AIRPORT.ERROR, payload: { response: error, params } });
      dispatch(resetTableRowUpdate({ data: params, table }));
      return error;
    });
};

export const archiveAirport = params => dispatch => {
  dispatch({ type: TYPES.ARCHIVE_AIRPORT.START, payload: { params } });

  return put(`/enums/airports/${params.id}/archive`)
    .then(response => {
      dispatch({ type: TYPES.ARCHIVE_AIRPORT.SUCCESS, payload: response.data });

      return response.data;
    })
    .catch(error => dispatch({ type: TYPES.ARCHIVE_AIRPORT.ERROR, payload: error }));
};

export const unArchiveAirport = params => dispatch => {
  dispatch({ type: TYPES.UNARCHIVE_AIRPORT.START, payload: { params } });

  return put(`/enums/airports/${params.id}/unarchive`)
    .then(response => {
      dispatch({ type: TYPES.UNARCHIVE_AIRPORT.SUCCESS, payload: response.data });

      return response.data;
    })
    .catch(error => dispatch({ type: TYPES.UNARCHIVE_AIRPORT.ERROR, payload: error }));
};
